import { format } from 'date-fns'
import PropTypes from 'prop-types'
import { CellSignalHighIcon, WifiMediumIcon, BatteryHighIcon } from '@phosphor-icons/react'

const PhoneContainer = ({ children }) => {
  const now = new Date()
  const currentTime = format(now, 'HH:mm')

  return (
    <div className="phone-container">
      <div className="phone-container__inside">
        <div className="phone-container__header">
          <div className="time">{currentTime}</div>
          <div className="icons">
            <CellSignalHighIcon size={16} color="#fff" />
            <WifiMediumIcon size={16} color="#fff" />
            <BatteryHighIcon size={16} color="#fff" />
          </div>
        </div>
        <div className="phone-container__content">{children}</div>
      </div>

      <img className="phone-container__image" src="/images/iphone-preview.png" />
    </div>
  )
}

PhoneContainer.propTypes = {
  children: PropTypes.node,
}

export default PhoneContainer
